import * as ActivityDefaults from '@revelio/data-access/activity-defaults';

import type { TreeFilter } from '../types/filters';

// Only the GENERATED_DEFAULT_CUSTOM_ACTIVITY_* arrays are selectable defaults;
// exclude the GENERATED_ACTIVITY_DEFAULTS_VERSION string stamp.
type ActivityDefaultsKeys = Exclude<
  keyof typeof ActivityDefaults,
  'GENERATED_ACTIVITY_DEFAULTS_VERSION'
>;

/**
 * Resolve the generated default ACTIVITY selections for an activity taxonomy
 * id (0 = the default taxonomy, higher ids = custom taxonomies — the same
 * numeric id the ACTIVITY_TAXONOMY filter carries). Falls back to the default
 * taxonomy's list for an unrecognised id, and to `[]` when even that is absent
 * (the generator was run against an environment without `default_ids`).
 *
 * Keep the key format in sync with the generator's `formatTaxonomyName()`:
 * DEFAULT for 0, CUSTOM_<id> otherwise.
 */
export function getActivityDefaultSelectionsForTaxonomy(
  taxonomyId: number | undefined
): TreeFilter['selections'] {
  const idNum = Number(taxonomyId ?? 0);
  const nameSegment =
    Number.isNaN(idNum) || idNum === 0 ? 'DEFAULT' : `CUSTOM_${idNum}`;
  const key =
    `GENERATED_DEFAULT_CUSTOM_ACTIVITY_${nameSegment}` as ActivityDefaultsKeys;

  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: keyed lookup over the generated module
  const forTaxonomy = ActivityDefaults[key];
  if (forTaxonomy) return forTaxonomy;

  // biome-ignore lint/performance/noDynamicNamespaceImportAccess: see above
  return ActivityDefaults['GENERATED_DEFAULT_CUSTOM_ACTIVITY_DEFAULT'] ?? [];
}
